/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ file: NonNullable<unknown>, error: NonNullable<unknown> }} Subtitle_Import_Multi_File_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to import {file}: {error}" |
*
* @param {Subtitle_Import_Multi_File_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_multi_file_failed_toast = /** @type {((inputs: Subtitle_Import_Multi_File_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Multi_File_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l'importation de ${i?.file} : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Import von ${i?.file} fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile importare ${i?.file}: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось импортировать ${i?.file}: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo importar ${i?.file}: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入 ${i?.file} 失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.file} のインポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.file} आयात नहीं हो सका: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao importar ${i?.file}: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to import ${i?.file}: ${i?.error}`)
});